import { render, staticRenderFns } from "./SyAudioPlayer.vue?vue&type=template&id=571a18c0&scoped=true"
import script from "./SyAudioPlayer.vue?vue&type=script&lang=ts"
export * from "./SyAudioPlayer.vue?vue&type=script&lang=ts"
import style0 from "./SyAudioPlayer.vue?vue&type=style&index=0&id=571a18c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a18c0",
  null
  
)

export default component.exports